import { render } from "./HistorialPagosRestaurante.vue?vue&type=template&id=5c6ab186&scoped=true"
import script from "./HistorialPagosRestaurante.vue?vue&type=script&lang=js"
export * from "./HistorialPagosRestaurante.vue?vue&type=script&lang=js"

import "./HistorialPagosRestaurante.vue?vue&type=style&index=0&id=5c6ab186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6ab186"]])

export default __exports__